/**
 * 解析静态资源基路径（以 / 结尾）。
 * 步骤1：工作台用 Vite BASE_URL（如 / 或 /dashboard/）
 * 步骤2：阅读端以当前 JS（assets/book-*.js）的父目录为包根，
 *       对应部署目录 resourceFiles/_storybook/reader/（测试 test2 / 正式 book）
 */
export function resolveStaticBase(): string {
  if (import.meta.env.APP !== 'reader') return import.meta.env.BASE_URL;

  // 例：.../resourceFiles/_storybook/reader/assets/book-xxx.js → .../reader/
  return new URL('../', import.meta.url).href;
}

/**
 * 解析应用内置静态资源最终加载地址（与 FontManager 字体路径规则一致）。
 * 已是 http(s)/协议相对路径时原样返回；否则相对 resolveStaticBase 拼接。
 *
 * 兼容旧数据中的 Vite dev 路径 `/src/assets/...`：去掉 `src/assets/` 前缀，
 * 与 public 下稳定路径对齐（dev 由 Vite 直接提供 public，无需走 /src/assets）。
 */
export function resolveAppStaticPath(path: string): string {
  if (!path) return path;
  if (/^(?:https?:)?\/\//i.test(path)) {
    return path;
  }

  const dashboardPrefix = String(import.meta.env.VITE_DASHBOARD_PREFIX || '').replace(
    /^\/+|\/+$/g,
    ''
  );
  let relativePath = path.replace(/^\/+/, '');
  if (
    dashboardPrefix &&
    (relativePath === dashboardPrefix || relativePath.startsWith(`${dashboardPrefix}/`))
  ) {
    relativePath = relativePath.slice(dashboardPrefix.length).replace(/^\/+/, '');
  }

  // 去掉 Vite 开发态残留的 src/assets/，统一走 public 目录结构
  relativePath = relativePath.replace(/^src\/assets\//, '');
  // 兼容旧路径 images/book/tail-page → images/tail-page
  relativePath = relativePath.replace(/^images\/book\/tail-page\//, 'images/tail-page/');

  return `${resolveStaticBase()}${relativePath.replace(/^\.\//, '')}`;
}
